import { TableLimit } from '@/datamodel/types'
import { LogoutParams } from '@/datamodel/urlparams/LogoutParams'
import { Options, Vue } from 'vue-class-component'
import { Action, Getter } from 'vuex-class'
import { generateRandomNumber } from '../../utils'
import { useI18n } from 'vue-i18n'
import { getImage, login } from '@/api'
import { LoginData, UserSessions } from 'vue'
import { store } from '@/store'
import { AppMutation } from '@/store/module/app'
import { UserMutation } from '@/store/module/user'
import { EventBuss } from '@/utils/constants'
import { ROUTES } from '@/router'

@Options({})
export class LoginMixin extends Vue {
    errorMessage = ''
    uname = ''
    pwd = ''
    captcha = ''
    cpth = ''
    imgSrc = ''
    headerToken = ''
    isLoadingCapcha = false

    $router!: Vue['$router']
    emitter!: Vue['emitter']

    iN = useI18n().t

    //#region Vuex
    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('authenticateUser') auth!: (model: LogoutParams) => Promise<string>
    @Action('trialoLogin') trialoLogin!: () => Promise<string>
    @Action('setBetCoin') setBetCoin!: (betCoin: number) => void
    @Action('createSession') createSession!: (model: SessionModel) => void
    @Action('setTableLimits') setTableLimits!: (
        model: Array<TableLimit>
    ) => void
    @Action('setLobyNotice') setLobyNotice!: (notice: string) => void

    @Getter('lang') lang!: string
    @Getter('serverLine') serverLine!: number
    //#endregion

    //#region Vue Methods
    beforeMount(): void {
        if (this.serverLine <= 0 && this.serverLine !== -1) {
            this.$router.push({ name: ROUTES.SERVER_SELECTION })
            return
        }

        // this.resetCapcha()
        this.getImageSrc()
    }
    //#endregion

    //#region Helpers

    //#endregion

    //#region Click Events
    doLoginWithCaptcha(): void {
        if (this.uname.length === 0) {
            this.errorMessage = '请输入用户名'
            return
        }
        if (this.pwd.length === 0) {
            this.errorMessage = '请输入密码'
            return
        }

        // if (this.captcha + '' === '') {
        //     this.errorMessage = '验证码不正确'
        //     return
        // }

        this.errorMessage = ''
        this.requestLogin()
    }

    doLogin(): void {
        if (this.uname.length === 0) {
            this.errorMessage = '请输入用户名'
            return
        }
        if (this.pwd.length === 0) {
            this.errorMessage = '请输入密码'
            return
        }

        this.errorMessage = ''
        this.requestLogin()
    }

    getImageSrc() {
        if (!this.isLoadingCapcha) {
            this.isLoadingCapcha = true
            getImage()
                .then(r => {
                    this.isLoadingCapcha = false
                    if (r.status === 200) {
                        this.headerToken = r.headers['access-token']
                        const reader = new window.FileReader()

                        reader.readAsDataURL(r.data)
                        reader.onload = () => {
                            const imageData = reader.result
                            this.imgSrc = imageData as string
                        }
                    }
                })
                .then(() => {
                    this.isLoadingCapcha = false
                })
        }
    }

    OnCLickedServer(): void {
        window.open(process.env.VUE_APP_CUSTUMER_SERVICE, '_blank')
    }

    requestLogin(): void {
        // show loading
        this.showLoading()

        const params = {
            params: {
                userName: this.uname,
                password: this.pwd,
                verifyCode: this.cpth
            },
            token: this.headerToken
        }

        login<LoginData>(params)
            .then(r => {
                this.hideLoading()
                const response = r.data
                if (response.status === 200) {
                    const { token, code, amount, id } = response.data.userInfo

                    const userSession: UserSessions = {
                        token,
                        username: code,
                        point: amount,
                        notice: '',
                        memberId: id
                    }

                    store.commit(UserMutation.SET_SESSION, userSession)
                    store.commit(
                        UserMutation.SET_USER_INFO,
                        response.data.userInfo
                    )

                    this.emitter.emit(EventBuss.SOCKET_CONNECT)

                    this.$router.push({
                        name: ROUTES.LOBY
                    })
                } else {
                    this.getImageSrc()
                    this.errorMessage = response.description
                }
            })
            .catch(() => {
                this.hideLoading()
                this.getImageSrc()
                this.errorMessage = this.iN('prompt.networkerror')
            })
    }

    resetCapcha(): void {
        this.captcha = generateRandomNumber(1000, 9999).toString()
    }
    //#region

    //#region Events
    checkCapchaLenght(e: KeyboardEvent): void {
        if (e.code === 'KeyE') {
            e.preventDefault()
            return
        }

        if (document.getSelection()?.toString() === this.cpth.toString()) {
            return
        }

        if (this.cpth.toString().length > 3 && e.code !== 'Backspace')
            e.preventDefault()
    }
    //#endregion
}
